import register from '@/components/features/cms/blocks/ProductCard/register';
import { ProductCardWithOverrides } from './ProductCardWithOverrides';

register(ProductCardWithOverrides);
